import { useTranslation } from 'next-i18next'
import { RefObject, useEffect } from 'react'

export const useEmailInputValidationLocale = (email: string, ref: RefObject<HTMLInputElement>): void => {
  const { t } = useTranslation('errors')
  useEffect(() => {
    const input = ref.current
    if (input?.validity) {
      const validityState = input.validity
      if (validityState.valueMissing) {
        input.setCustomValidity(t('fieldRequired'))
      } else if (validityState?.typeMismatch) {
        input.setCustomValidity(t('invalid_email'))
      } else {
        input.setCustomValidity('')
      }
    }
  }, [email, ref, t])
}
